if ('OTPCredential' in window) {
    window.addEventListener('DOMContentLoaded', e => {
        const input = document.querySelector('input[autocomplete="one-time-code"]');
        if (!input) return;

        navigator.credentials.get({
            otp: { transport:['sms'] },
        }).then(otp => {
            input.value = otp.code;

            $.ajax({
                type: 'POST',
                url: '/ajax/check-code',
                data: {
                    code: $('[name ="code"]').val(),
                },
                dataType: "json",
                success: function (data) {
                    if (data) {
                        $('.button--password').removeClass('button--in-active');
                    } else {
                        $('.number__error').show()
                    }
                },
                errors: function (errors) {
                    console.log(errors);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    });
}
